import {segmentationToPropertyItem} from 'common/query-builder/query-block/properties-menu/util';
import {promisifyModal} from 'common/components/modal/utils';
import type {Segmentation} from 'common/types/reports/query';
import {
  MapLookupTableModalAttrs,
  MapLookupTableModalEl,
  PropertyItemWithValue,
  // eslint-disable-next-line import/no-cycle
} from 'common/widgets/map-lookup-table-modal';
import {QueryEntrySectionTrackingEvent} from 'common/query-builder/query-entry-section/tracking';

import type {EntryRowProps} from '../types';

export async function mapLookupTable(props: EntryRowProps, segmentation: Segmentation) {
  const property = segmentationToPropertyItem(segmentation);

  const attrs: Omit<MapLookupTableModalAttrs, `open`> = {
    'project-id': props.sectionProps.projectId!,
    'workspace-id': props.sectionProps.workspaceId!,
    'user-id': props.sectionProps.userId!,
    'project-has-people': !!props.sectionProps.projectHasPeople,
    'selected-property': JSON.stringify(property) as unknown as PropertyItemWithValue,
    'event-names': props.sectionProps.eventNames,
    'disable-property-selection': true,
    elref: `mapLookupTableModal`,
    type: `temporary-map`,
  };

  props.dispatchTrack(QueryEntrySectionTrackingEvent.MapTableClicked, {
    ...props.getEntryTrackingProps(props.entry),
  });

  await promisifyModal({
    panelElement: MapLookupTableModalEl,
    closeEvents: [`close`],
    attrs,
  });
}
